<template>
  <transition name="fade">
    <div
      v-if="showPreSubmit"
      id="_tlqn_member_questionnaire_pre_submit_con"
      class="full-width"
      :style="{
        ...(!!loadingText
          ? {
              backdropFilter: 'blur(12px) saturate(180%)',
            }
          : {}),
      }"
    >
      <div class="tlqn-pre-submit-frame column items-center justify-center">
        <p class="q-mb-xs">是否完成并提交</p>
        <p class="counter q-mb-xs">
          已访问章节完成情况
          <span
            :class="{
              'text-red': count.completed !== count.sum,
            }"
          >
            {{ count.completed }}
          </span>
          /
          <span>{{ count.sum }}</span>
        </p>
        <p class="q-mb-md">(已答数量/应答数量)</p>

        <p
          class="text-red"
          v-if="inputErrorQuestions && inputErrorQuestions.length"
        >
          <q-icon name="fas fa-bomb" size="12px" class="q-mr-sm" />
          <span> {{ inputErrorQuestions.length }} 个问题的表单输入有误 </span>
          （
          <span>
            {{ inputErrorQuestions.slice(0, 3).join("、") }}
            <span v-if="inputErrorQuestions.length > 3">...</span>
          </span>
          ）
        </p>
        <p class="text-amber" v-if="notVistedUnit && notVistedUnit.length">
          <q-icon
            name="fas fa-exclamation-triangle"
            size="12px"
            class="q-mr-sm"
          />
          <span>还有 {{ notVistedUnit.length }} 个章节的问题尚未回答</span>
        </p>

        <div
          class="row items-center justify-between full-width q-px-xl q-mt-lg"
        >
          <section class="row items-center">
            <q-btn
              :loading="!!loadingText"
              outline
              color="white"
              @click="() => (showPreSubmit = false)"
            >
              取消
            </q-btn>
            <q-btn
              :loading="!!loadingText"
              outline
              color="primary"
              class="q-ml-md"
              @click="submitStashAnswerAndQuit"
            >
              暂存
            </q-btn>
          </section>

          <section>
            <q-btn
              :loading="!!loadingText"
              flat
              class="bg-primary text-white q-px-lg"
              @click="submitQuestionnaireAndQuit"
            >
              提交
            </q-btn>
          </section>
        </div>
      </div>

      <q-dialog :value="!!loadingText" persistent>
        <q-card
          style="height: 300px;width: 300px"
          class="column items-center justify-center"
        >
          <Loading :text="loadingText" />
        </q-card>
      </q-dialog>
    </div>
  </transition>
</template>

<script>
import QuestionnaireMixin from "./questionnaire.mixin";
import { styleLog } from "../../../utils/style-log";
import {
  STOP_VOICE_RECORDER_AND_UPLOAD,
  VOICE_RECORDER_UPLOADED,
} from "@/bus/member.events";
import { EventBus } from "../../../bus";
import { updateAnswerProcess } from "@/api/endpoints/answer/updateAnswerProcess";
import SampleMixin from "../mixins/sample.mixin";
import { SAMPLE_INFO_CHANGED } from "@/bus/member.events";
import { ipcSendAndWait } from "@/utils/ipcSendAndWait";
import { REQ_CHECK_QUESTIONNAIRE } from "../../../bus/member.events";
import { beforeUploadVoiceCheck } from "@/api/endpoints/voice/beforeUploadVoiceCheck";

export default {
  components: {
    Loading: () => import("@/components/Loading"),
  },
  mixins: [QuestionnaireMixin, SampleMixin],
  data() {
    return {
      loadingText: "",
    };
  },
  methods: {
    /**
     * 暂存答案并退出
     */
    async submitStashAnswerAndQuit() {
      await this.checkQuestionnaire(true);
      this.loadingText = "正在上传录音";
      const updateVoiceRes = await this.uploadVoice();
      if (!updateVoiceRes) {
        this.$q.notify({
          type: "danger",
          message: "录音上传失败, 请尝试重新上传",
        });
        this.loadingText = "";
        return;
      }
      this.loadingText = "正在提交问卷内容";
      const stashRes = await this.submitStashedQuestionnaire();
      await this.submitProcess();
      if (stashRes) {
        this.$q.notify({ type: "success", message: "已暂存" });
      }
      this.resetQuestionnaire();
      this.$router.push({ name: "member_page" });
      this.loadingText = "";
    },

    /**
     * 最终提交问卷
     */
    async submitQuestionnaireAndQuit() {
      const ckd = await this.checkQuestionnaire();
      if (!ckd) return;

      this.loadingText = "正在上传录音";
      const updateVoiceRes = await this.uploadVoice();
      if (!updateVoiceRes) {
        this.$q.notify({
          type: "danger",
          message: "录音上传失败, 请尝试重新上传",
        });
        this.loadingText = "";
        return;
      }
      this.loadingText = "正在提交问卷内容";
      const submitRes = await this.submitQuestionnaire();
      await this.submitProcess();
      if (submitRes) {
        this.$q.notify({ type: "success", message: "已提交" });
      }
      this.resetQuestionnaire();
      this.$router.push({ name: "member_page" });
      this.loadingText = "";
    },

    /**
     * 先检查问卷内容
     */
    async checkQuestionnaire(nocheck = false) {
      this.loadingText = "正在检查问卷";
      try {
        const checkRes = await ipcSendAndWait(REQ_CHECK_QUESTIONNAIRE, nocheck);
        return checkRes;
      } catch (err) {
        console.log(err);
        this.$q.notify({ type: "danger", message: "检查问卷时出现错误" });
      } finally {
        this.loadingText = "";
      }
    },

    resetQuestionnaire() {
      this.showPreSubmit = false;
      this.currentQuestionGroup = null;
      EventBus.$emit(SAMPLE_INFO_CHANGED);
    },

    /**
     * 上传录音
     */
    async uploadVoice() {
      // 1. 检查录音上传等待
      try {
        const res = await beforeUploadVoiceCheck();
        if (res.status || res.error || res.message)
          throw Error(res.detail || res.message);
      } catch (err) {
        this.$q.notify({
          type: "danger",
          message: err.toString(),
        });
        return false;
      }
      EventBus.$emit(STOP_VOICE_RECORDER_AND_UPLOAD, this.currentSampleObj);
      return await new Promise((resolve) => {
        EventBus.$on(VOICE_RECORDER_UPLOADED, (res) => resolve(res));
        const timeout = setTimeout(() => {
          clearTimeout(timeout);
          resolve(false);
        }, 60000);
      });
    },

    async submitProcess() {
      const { count } = this;
      const { sum, completed, visited_group_count, group_count } = count;
      await updateAnswerProcess(
        this.currentSampleId,
        Math.min(1, completed / sum) *
          Math.min(1, visited_group_count / group_count)
      );
    },
  },
  computed: {
    contentsNotEmpty() {
      return this.flattenContents.filter((c) => !c.empty);
    },
    notVistedUnit() {
      return this.contentsNotEmpty.filter(
        (unit) => !this.validatedAnswerCache[unit.id]
      );
    },
    inputErrorQuestions() {
      const { validatedAnswerCache } = this;
      const groups = Object.keys(validatedAnswerCache);
      const res = [];
      for (let groupId of groups) {
        const g = validatedAnswerCache[groupId];
        const qIds = Object.keys(g);
        for (let qId of qIds) {
          const q = g[qId];
          if (q && q.error) res.push(qId);
        }
      }
      return res;
    },
    count() {
      const { validatedAnswerCache, questionGroupNotEmpty } = this;
      const res = Object.keys(validatedAnswerCache).reduce(
        (res, questionGroupId) => {
          const answers = validatedAnswerCache[questionGroupId];
          Object.keys(answers).forEach((questionId) => {
            const answer = answers[questionId];
            if (answer && answer.answer && answer.answer.length)
              res.completed++;
            res.sum++;
          });
          return res;
        },
        {
          sum: 0,
          completed: 0,
        }
      );
      console.log(validatedAnswerCache);
      res.visited_group_count = Object.keys(validatedAnswerCache).length;
      res.group_count = questionGroupNotEmpty.length;
      return res;
    },
  },
};
</script>

<style lang="scss">
@import "@/styles/quasar";
#_tlqn_member_questionnaire_pre_submit_con {
  height: calc(100% - 50px);
  position: fixed;
  background-color: rgba(0, 0, 0, 0.2);
  left: 0;
  bottom: 0;
  z-index: 10;
  overflow: hidden;

  .tlqn-pre-submit-frame {
    width: 100%;
    height: 360px;
    background-color: $tailong-dark-blue;
    color: #fff;
    font-weight: bold;
    box-shadow: 0px 20px 20px rgba(0, 0, 0, 0.2);
    z-index: 9;
    border-bottom-left-radius: $generic-border-radius;
    border-bottom-right-radius: $generic-border-radius;

    animation: slideInDown;
    animation-duration: 0.3s;
    @keyframes slideInDown {
      from {
        transform: translateY(-100%);
      }
    }

    .counter {
      font-size: 2rem;
    }
  }
}
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
</style>
